import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getSharedStats } from "../../services/GameService";
import StatsDisplay, { formatDate } from "./StatsDisplay";
import "./MyStatsPage.css";

// Public, read-only view of a patient's progress, opened from a share link.
// No login required — the unguessable token in the URL is the credential.
const SharedStatsPage = () => {
  const { token } = useParams();
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    getSharedStats(token)
      .then(setStats)
      .catch(() =>
        setError(
          "This link is invalid or has expired. Please ask for a new one."
        )
      )
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) {
    return (
      <div className="my-stats">
        <p>Loading progress…</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="my-stats">
        <p className="ms-error">{error}</p>
      </div>
    );
  }

  return (
    <div className="my-stats">
      <h1 className="ms-title">{stats.patient_name}'s Progress</h1>
      <p className="ms-encourage">Shared read-only progress report 🌿</p>

      <StatsDisplay stats={stats} />

      {stats.expires_at && (
        <p className="ms-share-expiry ms-shared-foot">
          This shared link expires {formatDate(stats.expires_at)}.
        </p>
      )}
    </div>
  );
};

export default SharedStatsPage;
